<div mat-dialog-title>
  <h1>Connect to TypeDB</h1>
  <tp-modal-close-button />
</div>
<div class="tp-modal-content">
  <tp-scroll-container class="tp-modal-body" mat-dialog-content>
    @if (!(isTypeDBVersion3_2OrLater$ | async)) {
      <h2>Install TypeDB Studio</h2>
      <div class="tp-download-studio">
        <mat-form-field class="tp-connection-selector">
          <mat-label>Operating System</mat-label>
          <mat-select [(value)]="operatingSystem">
            <mat-option [value]="OperatingSystem.MAC_X86_64">macOS Intel x86</mat-option>
            <mat-option [value]="OperatingSystem.MAC_ARM64">macOS arm64</mat-option>
            <mat-option [value]="OperatingSystem.LINUX_X86_64">Linux Intel x86</mat-option>
            <mat-option [value]="OperatingSystem.LINUX_ARM64">Linux arm64</mat-option>
            <mat-option [value]="OperatingSystem.WINDOWS_X86_64">Windows 64-bit</mat-option>
          </mat-select>
        </mat-form-field>
        <a class="tp-download-studio-button" [href]="studioDownloadLink$ | async" target="_blank">
          <tp-button [height]="44" buttonStyle="primary-outline green stroke" buttonId="downloadStudio">
            <i class="tp-download-icon fa-light fa-download"></i>
            Download
          </tp-button>
        </a>
      </div>
      <a class="tp-installation-options tp-external-link" [href]="(studioInstallDocsLink$ | async)" target="_blank">
        Other installation options<i class="fa-light fa-arrow-up-right"></i>
      </a>
      <hr/>
      <h2>Connect to TypeDB</h2>
      @if (ready$ | async) {
        <p>Copy the following connection string into TypeDB Studio</p>
        @if (connectionStringSnippet$ | async; as connectionString) {
          <div class="tp-code">
            <tp-code-snippet [snippet]="connectionString"/>
            <button
              class="btn-copy" aria-label="copy" matTooltip="Copy to clipboard"
              (click)="copy(connectionString.code, snackbar); $event.stopPropagation();"
            >
              <i class="fa-light fa-copy"></i>
            </button>
          </div>
        }
      } @else if (loading$ | async) {
        @if (parsedVersion$ | async; as version) {
          <tp-cluster-loading-tips [clusterVersion]="version"/>
        }
      }
    } @else if (!(ready$ | async)) {
      <p>Your cluster is currently being provisioned.</p>
      <p>Keep this browser tab focused, and we'll open TypeDB Studio automatically as soon as it's ready.</p>
      @if (parsedVersion$ | async; as version) {
        <tp-cluster-loading-tips [clusterVersion]="version"/>
      }
    } @else {
      <p>TypeDB Studio should've opened automatically. If it didn't, click below and input your password to connect to your cluster.</p>
      @if (data.cluster$ | async; as cluster) {
        <p>
          Your database password can be found in your downloaded credentials file if you have one
          (by default: <strong>{{ clusterCredentialFilename(cluster) }}</strong>).
        </p>
      }
    }
  </tp-scroll-container>

  @if (isTypeDBVersion3_2OrLater$ | async) {
    <div class="tp-btn-section">
      <div class="flex-spacer"></div>
      @if (readyStudioLink$ | async; as studioLink) {
        <a [href]="studioLink" target="_blank">
          <tp-button [enabled]="!!(ready$ | async)" buttonId="openStudio" buttonStyle="primary-outline white grey-stroke">Open TypeDB Studio</tp-button>
        </a>
      } @else {
        <tp-button [enabled]="false" buttonId="openStudio" buttonStyle="primary-outline white grey-stroke">Open TypeDB Studio</tp-button>
      }
    </div>
  }
</div>
